module.exports = __webpack_public_path__ + "static/media/volumeOne04.45f3faf7.jpg";